import { observer } from 'mobx-react';
import * as React from 'react';
import { injectTSDI } from '../../core/tsdi';
import { DefaultCheckbox } from '../field/default-checkbox';
import { scrollToScrollId } from '../arrow-down';
import { I18nStore } from '../../core/i18n-store';
import { Button } from '../button';
import { CookieTable } from './components';
import { CookieNoticeStore } from './store';
import { getMarketingInfo, getNecessaryInfo } from './info';

import './cookie-notice.scss';

export const LOCALSTORAGE_COOKIES = 'cookie-consent-1';

export interface CookieInfo {
    name: string;
    description: string;
    providers: string | React.ReactNode;
    expiration?: string;
}

const DETAILS_SCROLL_ID = 'details-scroll-id';

export const CookieNotice = observer(() => {
    const { translate } = injectTSDI(I18nStore);
    const { form, saveCookies, showNotice } = injectTSDI(CookieNoticeStore);
    const { necessary, marketing } = form.wrappedField;
    const [detailsActive, setDetailsActive] = React.useState(false);

    const toggleDetails = () => {
        setDetailsActive(!detailsActive);
        if (!detailsActive) {
            setTimeout(() => scrollToScrollId(DETAILS_SCROLL_ID), 1);
        }
    };

    const acceptAll = () => {
        necessary.reset(true);
        marketing.reset(true);
        saveCookies();
    };

    const acceptSelected = () => {
        saveCookies();
    };

    if (!showNotice) {
        return null;
    }

    return (
        <div className="cookienotice">
            <div className="cookienotice__container">
                <div>
                    <strong className="cookienotice__title">
                        {translate('onlinepages.cookies.title')}
                    </strong>
                    <p>{translate('onlinepages.cookies.description')}</p>
                </div>
                <div className="cookienotice__buttons">
                    <Button color="primary" onClick={acceptSelected}>
                        {translate('onlinepages.cookies.allow.selection')}
                    </Button>
                    <Button color="grey" onClick={acceptAll}>
                        {translate('onlinepages.cookies.accept.all')}
                    </Button>
                </div>
                <form className="cookienotice__selection">
                    <DefaultCheckbox
                        field={necessary}
                        label={translate('onlinepages.cookies.necessary')}
                        required
                        disabled
                    />
                    <DefaultCheckbox
                        field={marketing}
                        label={translate('onlinepages.cookies.marketing')}
                        required
                    />
                    <button
                        className={classnames('cookienotice__toggle-details', {
                            'cookienotice__toggle-details--active': detailsActive
                        })}
                        onClick={toggleDetails}
                        type="button"
                    >
                        {translate('onlinepages.cookies.details')}
                    </button>
                </form>
                <div
                    className={classnames('cookienotice__details', {
                        'cookienotice__details--active': detailsActive
                    })}
                    data-scroll-id={DETAILS_SCROLL_ID}
                >
                    <div className="cookienotice__details-wrapper">
                        <CookieTable
                            name={translate('onlinepages.cookies.necessary')}
                            rows={getNecessaryInfo()}
                        />
                        <CookieTable
                            name={translate('onlinepages.cookies.marketing')}
                            rows={getMarketingInfo()}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});
